//修改新设备保存列表
export const SEL_PMU='DEVICEMANAGEMENT/SREACH/DEVICE/INFO/SEL_PMU';
